import { render, staticRenderFns } from "./Oss.vue?vue&type=template&id=b7d5126e&scoped=true"
import script from "./Oss.vue?vue&type=script&lang=js"
export * from "./Oss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d5126e",
  null
  
)

export default component.exports